<template>
	<div class="promission-checkbox">
		<!-- 一级权限 -->
		<el-checkbox
			:indeterminate="isIndeterminate"
			:value="checkAll"
			@change="status => change(status, checkboxData.id)"
		>
			<span>
				{{ formatName(checkboxData.name, checkboxData.grayscaleLabel) }}
			</span>
		</el-checkbox>
		<!-- 二级权限 -->
		<div class="checkbox-box">
			<div v-for="item in checkboxData.operate" :key="item.id" class="child-checkbox">
				<el-checkbox
					:value="Boolean(item.selected)"
					@change="status => change(status, item.id)"
					:label="item.id"
					class="child-checkbox-item"
					>{{ formatName(item.name, item.grayscaleLabel) }}</el-checkbox
				>
				<!-- 三级权限 -->
				<div class="son-checkbox" v-for="val in item.operate || []" :key="val.id">
					<el-checkbox
						:value="Boolean(val.selected)"
						:label="val.id"
						@change="status => change(status, val.id)"
						>{{ formatName(val.name, val.grayscaleLabel) }}</el-checkbox
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		checkboxData: {
			type: Object,
			default() {
				return {};
			},
		},
		checkAll: {
			type: [Number, Boolean],
		},
	},
	data() {
		return {
			isIndeterminate: false,
			childVal: [],
			sonVal: [],
		};
	},
	computed: {},
	methods: {
		// 选中 / 取消
		change(val, id) {
			this.$emit('promission-change', val, id);
		},
		formatName(name, status) {
			if (status) {
				return `${name}（灰度）`;
			} else {
				return name;
			}
		},
	},
	components: {},
};
</script>

<style lang="scss" scoped>
.promission-checkbox {
  padding: 20px 26px 30px;
  border-top: 1px solid #e8e8e8;

  .checkbox-box {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;

    .child-checkbox {
      min-width: 260px;
      margin: 10px 22px;
      padding: 6px;
      border-radius: 6px;
      border: 1px solid rgba($color: #eee, $alpha: 0.6);

      .son-checkbox {
        display: flex;
        flex-direction: column;
        margin: 10px 22px;
      }
    }
  }
}
</style>
